<template>
  <div class="container" style="margin-bottom: 10px">
    <Skeletor
      v-if="isLoading"
      :shimmer="true"
      height="100vh"
      width="100%"
      style="margin-bottom: 0px"
    />
    <div v-else style="display: flex; flex-direction: column">
      <div style="display: flex; justify-content: space-between">
        <p style="font-size: 28px; font-weight: 600; color: #333333">
          Listado de usuarios bloqueados
        </p>
        <button
          class="btn btn-secondary"
          style="
            align-self: flex-end;
            margin-bottom: 12px !important;
            background-color: white !important;
            color: #0c75ba !important;
          "
          id="btn_refresh"
          @click="fetchBlockedContacts"
        >
          Refrescar <i class="fas fa-arrows-rotate"></i>
        </button>
      </div>
      <blocked-user-component
        v-for="(contact, index) in contacts"
        :tokenAuth="tokenAuth"
        :contact="contact"
        :index="index"
        :key="index"
      />
    </div>
  </div>
</template>

<script>
import BlockedUserComponent from "./BlockedUserComponent.vue";

export default {
  name: "BlockedUsersList",
  components: { BlockedUserComponent },
  props: ["tokenAuth"],
  data() {
    return {
      isLoading: true,
      contacts: null,
    };
  },
  computed: {},
  watch: {},
  methods: {
    fetchBlockedContacts() {
      this.isLoading = true;
      this.$https
        .get("/hubspot/fetchBlockedContacts")
        // .post("/hubspot/fetchBlockedContacts", {
        //   tokenAuth: this.tokenAuth,
        // })
        .then((response) => {
          this.isLoading = false;
          // Filter out null values before sorting
          this.contacts = response.data.list
            .filter((contact) => contact !== null)
            .sort((a, b) => {
              const timeA =
                a.createdAt._seconds * 1000 + a.createdAt._nanoseconds / 1e6;
              const timeB =
                b.createdAt._seconds * 1000 + b.createdAt._nanoseconds / 1e6;
              return timeB - timeA;
            });
        })
        .catch((error) => {
          console.log(error);
          this.$toast.error(error.data.message, {
            position: "top-right",
            max: 10,
          });
        });
    },
  },
  mounted() {
    this.fetchBlockedContacts();
    this.$eventBus.on("refreshBlockedContacts", this.fetchBlockedContacts);
  },
  beforeUnmount() {
    this.$eventBus.off("refreshBlockedContacts", this.fetchBlockedContacts);
  },
};
</script>

<style></style>
